import * as React from 'react'

function SvgIm(props) {
	return (
		<svg viewBox="0 0 600 300" width="1em" height="1em" {...props}>
			<path d="M0 0h600v300H0z" fill="#cf142b" />
			<path
				d="M309.846 214.989c.101-.308.306-3.48.204-3.48-.103 0-4.809-5.524-4.706-5.524.102 0 6.036 1.33 6.036 1.125 0-.204 2.353-5.831 2.353-5.934 0-.101 2.865 6.855 2.865 6.855l5.832 2.559-4.093 3.375s.921 6.549.921 6.651c0 .102-4.093-3.888-4.093-3.888l-4.502.511s-.613-2.046-.817-2.25z"
				fontSize={12}
				fill="#f9dd16"
				fillOpacity={0.988}
				fillRule="evenodd"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M278.145 129.01c-3.887 2.003-18.807 19.057-20.854 21.717-1.714 3.862-5.067 8.747-8.521 11.892-3.687 2.789-5.736 6.6-5.228 10.207-.041 4.49 2.476 7.546 4.48 10.705 1.187 1.443 2.784 2.376 4.482 2.489 3.482.46 3.791 1.532 5.534 2.196 6.866 9.348 17.109 16.242 24.486 21.703 4.702 2.478 7.972 4.956 9.092 6.31 2.16 4.123 1.762 8.145 1.466 10.12l-5.476 20.664c-.921 5.627 3.969 4.361 4.232 3.236 2.207-2.865 5.5-.853 10.206-17.427l6.473-8.713s2.49-.996 2.49-1.245c3.786-4.545.903-7.147-1.245-7.966-1.577-.58-3.154-1.162-4.73-1.743 0 0-5.477-5.477-5.726-5.477-2.602-7.57-15.377-23.734-18.344-25.984-2.054-2.14-3.032-3.053-4.981-4.243-2.998-1.434-3.965-1.9-5.802-2.633-1.528-.614-.44-2.292.532-3.06 10.119-5.507 18.14-11.629 27.848-17.852l1.494-.996-3.485-19.916-16.182-5.726c-.849.58-1.493 1.162-2.24 1.743z"
				fontSize={12}
				fill="#fff"
				fillRule="evenodd"
				stroke="#000"
				strokeWidth={1.2998568000000001}
			/>
			<path
				d="M291.685 233.866c.051-.205 10.128-2.047 10.128-2.047s-1.176 3.735-1.228 3.735l-10.025 3.018 1.125-4.706z"
				fontSize={12}
				fill="#f9dd16"
				fillRule="evenodd"
			/>
			<path
				d="M265.425 195.922c1.943-5.166 7.34-9.257 10.964-10.386"
				fontSize={12}
				fill="none"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M291.323 233.956c.65-.183 3.539-1.026 4.38-1.157.897-.21 1.79-.445 2.654-.723.996-.204 1.62-.391 2.654-.58.81-.309 1.61-.52 2.477-.723m-13.99 9.414c.084-.113.77-.72 1.264-1.013.58-.183 2.567-1.026 3.318-1.157.802-.21 1.6-.445 2.37-.723.89-.204 1.446-.391 2.37-.58.724-.309 1.44-.52 2.213-.723"
				fontSize={12}
				fill="none"
				stroke="#000"
				strokeWidth={1.2389915999999999}
			/>
			<path
				d="M293.59 197.385h-.144c.453 0 .174-.038-.435.723-.217.585-2.074 1.88-3.472 1.88a26.43 26.43 0 01-2.388.145c-.192 0-.458-.144-.651-.144M293.446 227.191h.144.578c.75 0 1.504.134 2.171.145.724 0 1.447.205 2.17.205.731.103 1.61.07 2.366.177.847.029 1.527.196 2.409.196.71.027 1.094.145 1.882.145l-1.882-.145c.71.027 1.094.145 1.882.145M288.526 244.843c.077-.113.706-.72 1.157-1.013.532-.183 2.35-1.026 3.039-1.157a23.79 23.79 0 002.17-.724c.815-.203 1.324-.39 2.17-.579.664-.309 1.318-.52 2.026-.723M302.075 219.693c-.409 1.189.121 1.487.34 2 .382.496 1.356 1.254 2.895 1.736.593.16 1.05.316 1.736.579.455.042.679.155 1.013.289M244.83 176.115h.144c-.454 0-.182.03.579-.579.47-.525.862-.763 1.302-1.302M254.198 186.423c.097 0 8.417-4.194 9.305-5.09.63-.456 1.106-.938 1.872-1.456.49-.256.843-.585 1.303-.868.382-.554.881-.889 1.157-1.395.51-.443.291-.923.706-1.457.196-.546.562-1.466.681-1.966M279.82 180.414c.045.299-.133 1.22-.12 1.923-.03.813-1.075 3.326-2.34 4.076"
				fontSize={12}
				fill="none"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M264.87 180.32c.05 0 1.316.412 3.433 1.064 2.548.916 7.847 4.255 8.374 4.715.537.423 1.497.8 1.865 1.302.576.497.998 1.071 1.447 1.591.529.645.98 1.19 1.302 1.737 1.61 1.305 5.938 10.341 6.077 10.852.243.477.544 1.142.723 1.591.321.37.54.893.869 1.447.302.72.64 1.048 1.013 1.592.48.333 1.125.965 1.736 1.302.652.558 1.264.785 1.737 1.158.682.29 8.308 5.11 8.661 5.351.697.56 2.824 2.765 1.33 4.368-.633.542-1.204 1.26-1.745 1.566-.551.553-1.318.8-1.952 1.085-3.435 1.016-5.185.652-5.86.652h-.724M248.029 163.273c.976.383.582.1 1.461.5.59.26.98.266 1.56.478.617.197 2.338.507 3.165 1.338.606.548 1.07 1.01 1.736 1.41.788.544 1.357.786 2.335 1.194.824.308 1.746.65 2.58.68.866.05 1.074.007 1.905.007h2.026-2.026 2.026"
				fontSize={12}
				fill="none"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M247.796 172.932c2.17-.145 5.787.507 5.859.507l4.775-.073c2.509-.242 3.062-1.206 3.473-1.881.94-1.447 1.591-1.953 2.315-3.038 1.157-.868 2.75 1.157 2.822 1.157 4.05 3.835.795 8.537.578 8.681-2.025 1.857-2.46 1.978-3.69.796-1.23-1.447-1.591-2.098-2.604-2.604-1.953-.94-6.004-.217-6.077-.217-.073 0-2.098.796-2.098.796-.989.361-1.616 1.23-3.328 1.518-1.736.121-2.315-.048-3.183-1.446-1.157-1.809-.58-3.98 1.158-4.196z"
				fontSize={12}
				fill="#ffe606"
				fillRule="evenodd"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M361.08 85.175c-.319.063-3.184 1.438-3.134 1.527.05.09-2.459 6.9-2.509 6.81-.05-.09-1.799-5.914-1.977-5.813-.178.1-6.237.807-6.326.857-.089.05 4.571-5.857 4.571-5.857l-.628-6.337 4.948 1.913s5.257-4.012 5.346-4.062c.089-.05-1.383 5.473-1.383 5.473l2.652 3.674s-1.483 1.537-1.56 1.815z"
				fontSize={12}
				fill="#f9dd16"
				fillOpacity={0.988}
				fillRule="evenodd"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M301.67 154.944c3.65 2.408 25.829 7.055 29.15 7.535 4.206-.398 10.108.131 14.542 1.6 4.238 1.847 8.563 1.766 11.46-.445 3.933-2.164 5.364-5.856 7.134-9.152.677-1.741.707-3.59-.026-5.126-1.306-3.26-.523-4.056-.798-5.9 4.784-10.567 5.773-22.874 6.918-31.98-.144-5.313.413-9.378 1.044-11.018 2.536-3.903 6.236-5.528 8.103-6.238l20.696-5.353c5.356-1.955 1.857-5.597.747-5.275-3.58-.52-3.44-4.377-20.193-.356l-10.767-1.372s-2.089-1.682-2.305-1.56c-5.818-1.073-6.673 2.715-6.334 4.99l.799 4.976s-2.09 7.458-1.968 7.675c-5.324 5.98-13.25 25.179-13.757 28.869-.24 3.467-1.55 2.84-1.198 6.21.013 2.634-.293.99.586 6.415.214 1.633-1.782 1.507-2.927 1.035-9.76-6.12-19.027-10.112-29.21-15.524l-1.6-.814-15.652 12.798 2.939 16.912c.922.455 1.745.732 2.617 1.098z"
				fontSize={12}
				fill="#fff"
				fillRule="evenodd"
				stroke="#000"
				strokeWidth={1.2998568000000001}
			/>
			<path
				d="M386.434 91.754c-.203.056-6.748-7.825-6.748-7.825s3.832-.805 3.857-.76l7.545 7.26-4.654 1.325z"
				fontSize={12}
				fill="#f9dd16"
				fillRule="evenodd"
			/>
			<path
				d="M366.23 133.24c-5.457.838-11.667-1.86-14.428-4.467"
				fontSize={12}
				fill="none"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M386.69 92.026c-.478-.478-2.628-2.582-3.155-3.251a33.76 33.76 0 00-1.931-1.959c-.666-.768-1.135-1.22-1.806-2.03-.666-.554-1.243-1.148-1.845-1.804m15.063 7.58c-.14-.018-1.005-.319-1.503-.605-.444-.416-2.152-1.734-2.634-2.325a27.603 27.603 0 00-1.792-1.711c-.614-.676-1.05-1.07-1.667-1.783-.624-.479-1.16-.999-1.715-1.573"
				fontSize={12}
				fill="none"
				stroke="#000"
				strokeWidth={1.2389915999999999}
			/>
			<path
				d="M353.7 107.973l.071.126c-.222-.395-.118-.134.844.024.616-.098 2.656.886 3.341 2.105.394.553.965 1.421 1.296 2.01.095.168.099.47.194.639M379.753 93.49l-.07-.125-.284-.504c-.368-.654-.62-1.376-.938-1.963-.355-.631-.53-1.362-.885-1.993-.268-.687-.728-1.438-1.005-2.149-.39-.752-.578-1.427-1.01-2.195-.325-.633-.41-1.025-.795-1.712l.795 1.712c-.325-.633-.41-1.025-.795-1.712M397.55 89.128c-.136-.012-.973-.262-1.45-.512-.42-.374-2.046-1.546-2.497-2.082a23.79 23.79 0 00-1.695-1.537c-.576-.61-.99-.963-1.568-1.608-.595-.426-1.1-.893-1.623-1.41M368.988 89.643c1.236-.226 1.237-.834 1.576-1.277.246-.576.429-1.796.095-3.373a16.262 16.262 0 01-.346-1.798c-.186-.416-.197-.667-.245-1.024M359.058 160.9l-.071-.126c.222.396.114.144-.789-.221-.688-.152-1.087-.378-1.772-.497M363.45 147.682c-.047-.084-7.78-5.282-8.996-5.617-.706-.325-1.36-.505-2.187-.918-.464-.302-.923-.448-1.395-.71-.67-.062-1.206-.333-1.783-.325-.636-.228-.947.198-1.615.099-.573.097-1.554.228-2.049.37M345.656 128.293c.239-.186 1.13-.483 1.735-.837.723-.374 3.426-.694 4.7.041"
				fontSize={12}
				fill="none"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M352.901 141.37c-.024-.043-.285-1.349-.755-3.513-.45-2.67-.137-8.927.006-9.61.106-.676-.036-1.698.22-2.265.152-.745.446-1.394.679-2.041.303-.777.557-1.437.875-1.986.35-2.042 6.105-10.244 6.481-10.615.298-.446.73-1.034 1.033-1.41.165-.462.514-.908.836-1.467.48-.616.599-1.072.891-1.663.055-.58.29-1.453.284-2.152.167-.842.065-1.486.158-2.08-.081-.738.383-9.747.42-10.174.147-.881 1.026-3.816 3.155-3.3.783.287 1.688.433 2.221.754.752.21 1.343.758 1.903 1.17 2.568 2.497 3.108 4.2 3.44 4.79l.354.63M346.257 164.113l-.07-.126c.19.34.085.171-.159-.575-.063-.642-.261-1.51-.361-2.12-.13-.634-.427-1.356-.347-1.798-.227-.643-.084-1.175-.023-1.813.18-.797.262-1.374.284-2.15.087-.955.017-1.63.071-2.531-.25-.742-.302-1.363-.685-2.104-.34-.71-.601-1.365-1.009-2.09l-.993-1.766.993 1.767c-.33-.59-.662-1.178-.993-1.767"
				fontSize={12}
				fill="none"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M354.829 159.874c-1.19-1.82-2.395-5.292-2.43-5.355l-2.403-4.127c-1.44-2.068-2.552-2.079-3.342-2.105-1.722-.11-2.483-.43-3.783-.53-1.324-.583-.339-2.963-.374-3.026 1.357-5.41 7.051-4.877 7.284-4.759 2.611.855 2.929 1.175 2.501 2.826-.658 1.782-1.048 2.415-.993 3.547.137 2.163 2.753 5.34 2.79 5.404.035.063 1.72 1.438 1.72 1.438.8.685 1.865.806 2.956 2.157.956 1.454 1.092 2.041.299 3.483-1.01 1.895-3.185 2.455-4.225 1.047z"
				fontSize={12}
				fill="#f9dd16"
				fillRule="evenodd"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M238.862 224.504c.121-.366.365-4.14.243-4.14s-5.722-6.574-5.6-6.574c.122 0 7.183 1.583 7.183 1.339 0-.243 2.8-6.939 2.8-7.061 0-.121 3.409 8.157 3.409 8.157l6.939 3.044-4.87 4.017s1.096 7.792 1.096 7.914c0 .121-4.87-4.627-4.87-4.627l-5.357.609s-.73-2.435-.973-2.678z"
				fill="#f9dd16"
				fillOpacity={0.988}
				fillRule="evenodd"
				stroke="#000"
				strokeWidth="1pt"
				transform="matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
			/>
			<path
				d="M201.141 122.196c-4.626 2.382-22.38 22.676-24.815 25.841-2.04 4.595-6.03 10.408-10.14 14.15-4.387 3.319-6.825 7.853-6.221 12.146-.049 5.342 2.946 8.979 5.332 12.738 1.412 1.717 3.312 2.827 5.332 2.962 4.144.547 4.512 1.823 6.586 2.613 8.17 11.124 20.358 19.327 29.136 25.825 5.595 2.949 9.486 5.898 10.819 7.508 2.57 4.907 2.097 9.692 1.745 12.043l-6.517 24.588c-1.096 6.696 4.723 5.19 5.036 3.851 2.626-3.409 6.545-1.015 12.145-20.737l7.702-10.368s2.963-1.185 2.963-1.481c4.505-5.409 1.075-8.505-1.482-9.479l-5.628-2.074s-6.517-6.517-6.813-6.517c-3.097-9.009-18.39-28.426-21.921-31.104-3.456-2.271-2.043-3.264-5.743-4.865-2.739-1.522-.855-.881-6.995-3.133-1.819-.73-.524-2.727.633-3.64 12.04-6.554 21.584-13.838 33.137-21.244l1.777-1.185-4.147-23.698-19.255-6.814c-1.01.691-1.777 1.383-2.666 2.074z"
				fill="#fff"
				fillRule="evenodd"
				stroke="#000"
				strokeWidth={1.547}
				transform="matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
			/>
			<path
				d="M212.094 84.771c.158.14-2.85 9.932-2.85 9.932s-2.773-2.765-2.75-2.81l1.942-10.29 3.658 3.168z"
				fill="#f9dd16"
				fillRule="evenodd"
			/>
			<path
				d="M186.004 201.816c2.313-6.148 8.734-11.016 13.047-12.359"
				fill="none"
				stroke="#000"
				strokeWidth="1pt"
				transform="matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
			/>
			<path
				d="M216.821 247.074c.774-.218 4.211-1.221 5.212-1.377 1.068-.25 2.131-.53 3.158-.861 1.185-.242 1.927-.465 3.158-.689.964-.368 1.917-.62 2.948-.861m-16.647 11.202c.1-.134.917-.856 1.504-1.205.691-.218 3.054-1.221 3.948-1.377.954-.25 1.903-.53 2.82-.861 1.059-.242 1.721-.465 2.821-.689.861-.368 1.712-.62 2.632-.861"
				fontSize={12}
				fill="none"
				stroke="#000"
				strokeWidth={1.474}
				transform="matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
			/>
			<path
				d="M219.519 203.556h-.172c.539 0 .208-.045-.517.861-.258.696-2.468 2.238-4.132 2.238-.803.086-2.037.172-2.841.172-.229 0-.545-.172-.775-.172M219.347 239.024h.172.688c.893 0 1.789.159 2.583.172.861 0 1.722.244 2.583.244.869.123 1.916.083 2.815.211 1.008.034 1.817.233 2.866.233.846.032 1.302.173 2.239.173l-2.239-.173c.846.032 1.302.173 2.239.173M213.493 260.028c.092-.134.84-.856 1.377-1.205.633-.218 2.797-1.221 3.616-1.377.873-.25 1.742-.53 2.582-.861.97-.242 1.576-.465 2.583-.689.789-.368 1.568-.62 2.41-.861M229.616 230.102c-.487 1.414.144 1.769.405 2.379.454.591 1.613 1.492 3.444 2.066.706.19 1.249.376 2.066.689.541.05.807.185 1.205.344M161.497 178.247h.172c-.54 0-.216.035.689-.689.559-.625 1.026-.908 1.549-1.549M172.645 190.512c.115 0 10.016-4.99 11.073-6.056.749-.543 1.316-1.116 2.227-1.733.584-.305 1.003-.696 1.55-1.033.455-.659 1.049-1.057 1.377-1.66.608-.527.347-1.098.84-1.733.233-.65.669-1.745.811-2.34M203.133 183.362c.054.356-.158 1.453-.143 2.288-.034.968-1.279 3.958-2.784 4.851"
				fill="none"
				stroke="#000"
				strokeWidth="1pt"
				transform="matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
			/>
			<path
				d="M185.345 183.251c.058 0 1.565.49 4.084 1.265 3.032 1.09 9.338 5.064 9.964 5.611.639.503 1.782.952 2.22 1.549.685.592 1.187 1.275 1.722 1.894.629.767 1.165 1.416 1.549 2.066 1.915 1.553 7.066 12.306 7.231 12.913.289.568.647 1.359.861 1.894.382.44.641 1.062 1.033 1.722.36.856.763 1.246 1.206 1.894.57.396 1.338 1.148 2.066 1.549.776.664 1.504.934 2.066 1.378.812.345 9.886 6.081 10.307 6.368.829.666 3.36 3.289 1.583 5.197-.754.645-1.433 1.499-2.077 1.864-.656.657-1.569.951-2.323 1.291-4.088 1.208-6.17.775-6.974.775h-.861M165.629 163.096h.172c-.465 0-.227-.011.689.172.703.308 1.719.609 2.41.861.733.235 1.655.348 2.066.689.8.14 1.268.598 1.894 1.033.722.652 1.273 1.073 2.066 1.549.938.647 1.68.968 2.583 1.55.916.172 1.59.481 2.582.516.934.06 1.766.172 2.755.172h2.411-2.411 2.411M221.241 142.952h-.345c.637 0 .458-.023-.516.172-1.017.525-2.371.922-3.272 1.377-1.028.34-2.133.717-3.099 1.206-1.094.641-2.102 1.162-3.099 1.893-.991.531-1.965 1.185-2.927 1.722-.959.521-1.751 1.024-2.582 1.722-.694.385-1.637.93-2.411 1.549-.727.261-1.252.779-1.721 1.206-.911.807-1.469 1.226-2.411 2.066-.495.468-1.153 1.018-1.894 1.721-.778.519-1.62 1.517-2.238 2.066-.396.517-.976 1.132-1.549 1.55-.441.555-.952 1.285-1.55 1.722-.355.528-.976 1.216-1.55 1.894-.465.569-1.105 1.142-1.549 1.721-.598.662-1.056 1.329-1.722 1.894-.119.398-.369.604-.516.861"
				fill="none"
				stroke="#000"
				strokeWidth="1pt"
				transform="matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
			/>
			<path
				d="M165.027 174.459c2.582-.172 6.886.603 6.972.603l5.682-.086c2.985-.288 3.644-1.435 4.132-2.239 1.119-1.721 1.894-2.324 2.755-3.615 1.377-1.033 3.272 1.377 3.358 1.377 4.82 4.563.946 10.158.688 10.33-2.41 2.21-2.927 2.353-4.39.947-1.464-1.722-1.894-2.496-3.099-3.099-2.324-1.119-7.145-.258-7.232-.258-.086 0-2.496.947-2.496.947-1.177.43-1.923 1.464-3.96 1.807-2.066.144-2.755-.057-3.788-1.721-1.377-2.152-.689-4.735 1.378-4.993z"
				fill="#f9dd16"
				fillRule="evenodd"
				stroke="#000"
				strokeWidth="1pt"
				transform="matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
			/>
			<path
				d="M279.483 125.329c-.797-.723 14.975 5.715 17.145 5.788 2.966-1.085 15.193-11.43 15.193-11.43.12 1.012.554 3.64 1.735 4.196-4.726 3.834-9.019 7.523-13.745 11.357.338 6.077-.771 12.516 2.315 19.317 0 0-3.689.071-3.689 0-3.255-3.256-4.414-18.955-4.414-18.955-5.184-2.315-10.37-4.557-15.553-6.872.747-.483 1.35-1.978 1.013-3.401z"
				fontSize={12}
				fill="#f9dd16"
				fillOpacity={0.987}
				fillRule="evenodd"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
			<path
				d="M294.488 141.421c.252-.182-2.845 1.44-3.64 1.846-14.329 7.644-21.702 18.762-22.162 19.182-.247.473-.703 1.105-1.12 1.724-.336.519-.818 1.056-1.136 1.58-.439.608-1.362 1.809-1.866 2.342-.063.343.24-.118.14.11M304.278 132.338c-.278-.14 2.581 1.872 3.307 2.392 13.35 9.246 26.61 10.718 27.194 10.934.534.004 1.305.12 2.046.208.615.062 1.312.245 1.925.287.74.112 2.23.384 2.935.588.334-.101-.213-.158.035-.175"
				fontSize={12}
				fill="none"
				stroke="#000"
				strokeWidth={1.1204094}
			/>
		</svg>
	)
}

export default SvgIm
